import Icon from '../components/Icon.vue'

Icon.register({
  'globe-americas': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM330.3 365.6C326.4 369.5 322.3 373.6 319 376.9 316 379.9 313.9 383.6 312.8 387.6 311.3 393.3 310.1 399 308 404.5L290.7 451.3C276.9 454.3 262.7 456 248 456V428.6C249.7 416 240.4 392.4 225.4 377.4 219.4 371.4 216 363.2 216 354.7V322.7C216 311.1 209.7 300.4 199.5 294.8 185.2 286.8 164.7 275.7 150.7 268.6 139.3 262.9 128.6 255.5 119.1 246.9L118.3 246.2A114.8-114.8 0 0 0 100.2 225.4C90.8 211.7 75.6 189 65.6 174.3 86.1 128.8 123 92.3 168.8 72.4L192.8 84.4C203.5 89.7 216 82 216 70.1V58.8C224 57.5 232.1 56.7 240.4 56.4L268.7 84.7C274.9 90.9 274.9 101.1 268.7 107.3L264 112 253.7 122.3C250.5 125.5 250.5 130.5 253.7 133.6L258.4 138.3C261.5 141.5 261.5 146.5 258.4 149.6L250.3 157.6A8-8 0 0 0 244.7 160H235.7C233.6 160 231.6 160.8 230.1 162.3L220.2 171.9A8-8 0 0 1 218.6 181.2L234.2 212.4C236.9 217.7 233 224 227.1 224H221.4C219.5 224 217.6 223.3 216.2 222L206.9 214A16-16 0 0 1 191.3 210.9L160.2 221.3A11.9-11.9 0 0 1 152 232.6C152 237.1 154.6 241.3 158.6 243.3L169.7 248.8C179.1 253.5 189.5 256 200 256S222.6 283.3 232 288H298.8C307.3 288 315.4 291.4 321.4 297.4L335.1 311.1A30.5-30.5 0 0 0 344 332.6 46.5-46.5 0 0 0 330.3 365.6zM417 274.3C411.2 272.8 406.2 269.3 402.9 264.3L384.9 237.3A24-24 0 0 0 384.9 210.7L404.5 181.3C406.8 177.8 410 175 413.7 173.2L426.7 166.7C440.2 193.6 448 223.9 448 256 448 264.7 447.3 273.2 446.2 281.5L417 274.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/globe-americas.js
// module id = ILhE
// module chunks = 144